import React, { PropsWithChildren } from "react";
import { omit } from "lodash";

const styles = {
  container: {
    position: "relative",
    float: "left",
    height: 40,
    minWidth: 40,
    border: "1px solid #DCDCDC",
    borderRadius: 4,
    cursor: "pointer",
    marginLeft: -1,
  },
  containerPressed: {
    backgroundColor: "#e9e9e9",
    boxShadow: "rgba(0, 0, 0, 0.06) 0px 0px 5px inset",
  },
} as const;
type Props = {
  onClick?: () => void;
  className?: string,
  style?: React.CSSProperties
  width?: number,
  id?: string,
  disabled?: boolean,
}
const TableButton: React.FC<PropsWithChildren<Props>> = (props) => {
  const { style, width } = props;
  const [isPressed, setPressed] = React.useState(false);
  const pressedStyles = isPressed ? styles.containerPressed : {};
  const buttonStyles = { ...styles.container, width, ...pressedStyles };
  return (
    <div
      className="btn-table"
      style={{ ...buttonStyles, ...style }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      {...omit(props, "hasRightBorder", "style")}
    >
      {props.children}
    </div>
  );
};
export default TableButton;
